module.exports = __webpack_public_path__ + "assets/img/barchart.dbb38128.svg";